export default "__VITE_ASSET__fmF9dZ2T__"